import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { CommunicationAlert, CommunicationCategory } from '../../domain/Communication/entities';
import { CommunicationTask } from '../../domain/Communication/entities/CommunicationAlert';

export interface CommunicationProviderState {
  communicationAlertsList?: Nullable<CommunicationAlert[]>;
  selectedCommunicationAlert: Nullable<CommunicationAlert>;
  selectedCategory: Nullable<CommunicationCategory>;
  selectedTask: Nullable<CommunicationTask>;
  refetchCommunicationAlertListData: () => void;
  loadingState: {
    isLoadingCommunicationAlertsListData: boolean;
  };
  errorState: {
    communicationAlertsListDataError?: AxiosError<APIGatewayResponse<CommunicationAlert[]>, any>;
  };
}

export interface CommunicationProviderProps {}

export enum CommunicationActionTypes {
  setCommunicationAlerts = '@@Communication/setCommunicationAlerts',
}
